// 3rd Party
import React from 'react';

// Component
const VerifyPhoneAndEmailTwoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="105"
    height="40"
    role="presentation"
  >
    <defs>
      <linearGradient
        id="a"
        x1="87.348%"
        x2="15.658%"
        y1="639.063%"
        y2="639.063%"
      >
        <stop offset="0%" stopColor="#F37F6E" />
        <stop offset="100%" stopColor="#F37F6E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#a)" fillRule="nonzero" d="M72 19v3H34v-3z" />
      <rect width="40" height="40" fill="#F37F6E" rx="20" />
      <rect width="40" height="40" x="65" fill="#F37F6E" rx="20" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M76.136 13c-.618 0-1.136.518-1.136 1.136v10.91c0 .617.518 1.136 1.136 1.136h17.728A1.15 1.15 0 0095 25.045V14.136c0-.618-.518-1.136-1.136-1.136H76.136zm1.307 1.364h15.114l-7.316 6.534c-.1.089-.383.089-.483 0l-7.315-6.534zm-1.08.859l5.107 4.567-5.106 4.226v-8.793zm17.273 0v8.793L88.53 19.79l5.106-4.567zM82.5 20.706l1.35 1.207a1.714 1.714 0 002.3 0l1.35-1.207 4.972 4.112H77.528l4.972-4.112zm-55.26-5.362c-.415-.452-1.13-.452-1.582-.038l-7.045 6.667-3.692-3.692c-.452-.452-1.169-.452-1.582 0-.452.452-.452 1.169 0 1.582l4.444 4.484c.227.227.527.338.792.338a1.3 1.3 0 00.792-.301l7.798-7.422c.49-.451.49-1.167.075-1.618z"
      />
    </g>
  </svg>
);
export default VerifyPhoneAndEmailTwoSvg;
